import styled from 'styled-components';

import { Modal } from '@pkg/components/Modal';
import { Form } from '@pkg/components/Modal/styles';

export const ModalLayout = styled(Modal.Layout)`
    padding: 90px 25px 50px 25px;
    gap: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 80px 100px 80px 100px;
    }
`;

export const Heading = styled.div`
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: 0;

    font-size: 26px;
    line-height: 26px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 80px 100px 80px 100px;
        font-size: 48px;
        line-height: 48px;
        margin-bottom: 10px;
    }
`;

export const SubHeading = styled.div`
    opacity: 0.5;
    font-weight: 500;
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 20px;
        line-height: 20px;
    }
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 30px;

    .yat-checkbox__label {
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
        letter-spacing: -0.03em;
        text-align: left;
        color: ${({ theme }) => theme.colors.white};
    }
`;

export const EnvelopeImage = styled.img`
    width: 134px;
    height: 134px;
`;

export const StyledForm = styled(Form)`
    justify-content: center;
    align-items: center;
`;
